import { useCallback, useEffect, useState } from 'react';

export default function useColorScheme() {
    const systemPrefersDark = window.matchMedia('(prefers-color-scheme: dark)').matches;
    const localScheme = localStorage.getItem('scheme') || (systemPrefersDark ? 'dark' : 'light');
    const [isDark, setIsDark] = useState<boolean>(localScheme === 'dark' ? true : false);

    const setScheme = useCallback((scheme: 'dark' | 'light') => {
        setIsDark(scheme === 'dark');

        localStorage.setItem('scheme', scheme);
    }, []);

    useEffect(() => {
        if (isDark) {
            document.body.classList.add('dark');
        } else {
            document.body.classList.remove('dark');
        }
    }, [isDark]);

    return {
        isDark,
        setScheme
    };
}